import { defineMessages } from 'react-intl';

export default defineMessages({
    paAadditionalInterestDesc: {
        id: 'ml.quoteandbind.common.additionalInterest.Include any lienholders, additional owners, or other parties that have an interest in this vehicle',
        defaultMessage: 'Include any lienholders, additional owners, or other parties that have an interest in this vehicle'
    },
    hoAdditionalInterestDesc: {
        id: 'ml.quoteandbind.common.additionalInterest.Include additional mortgages, homeowner or condo associations, and third party designees.',
        defaultMessage: 'Include additional mortgages, homeowner or condo associations, and third party designees.'
    },
    rentersAdditionalInterestDesc: {
        id: 'ml.quoteandbind.common.additionalInterest.Include landlord, leasing company, trust, and third party designees.',
        defaultMessage: 'Include landlord, leasing company, trust, and third party designees.'
    },
    pupAdditionalInterestDesc: {
        id: 'ml.quoteandbind.common.additionalInterest.Include any trusts or third party designees',
        defaultMessage: 'Include any trusts or third party designees'
    },
    addInterestedParty: {
        id: 'ml.quoteandbind.common.additionalInterest.ADD INTERESTED PARTY',
        defaultMessage: 'ADD INTERESTED PARTY'
    },
    listAdditionalInterestedParty: {
        id: 'ml.quoteandbind.common.additionalInterest.List an additional interested party',
        defaultMessage: 'List an additional interested party'
    },
    mortgagePaymentError: {
        id: 'ml.policychange.common.additionalInterest.Mortgage payment method can not be selected without a Mortgage being added...',
        defaultMessage: 'Mortgage payment method can not be selected without a Mortgage being added...'
    },
    editItem: {
        id: 'ml.policychange.common.additionalInterest.Edit item',
        defaultMessage: 'Edit {item}'
    },
    removeItem: {
        id: 'ml.policychange.common.additionalInterest.Remove item',
        defaultMessage: 'Remove {item}'
    }
});
